// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { propertiesModel } from '@/firebase/firebase-config'

export const BindPropertyUnits = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        units: null,
        bind_property_units_complete: false

    }),

    /*
	**  Methods
    */
    
    methods: {

        bindPropertyUnitsHandler: function(property_id) {

            try {

                // Get the doc
                this.$bind('units', propertiesModel.doc(property_id).collection('units').where('meta.deleted_at', '==', null).orderBy('attributes.number', 'asc'))
                .then(() => {

                    /*
                    **  Set the completed event prop
                    **  @prop: @here
                    */

                    this.bind_property_units_complete = true;

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Bind Units from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Units',
                        uid: 'clFApiA7iTttbaIWMa7a',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Query for Units from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Units',
                    uid: 'ovRCTeh8bbJDttRf6pwi',
                    error: e
                });

            }

        }

    }

}